
import { Component, Vue } from 'vue-property-decorator';

import { getServiceList } from '@/api/service';

import eventBus from '@/utils/eventBus';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'orderSearch'
})
export default class extends Vue {
  private orderForm = {
    number: '',
    // startTime: '',
    // endTime: '',
    timePeriods: '',
    person: '',
    servicer: ''
  }
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, start]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }
  private params: object = {
    company_id: UserModule.getCompanyId
  }

  private servicerOptions = [] // 应该是请求接口过来的

  created() {
    getServiceList(this.params).then(res => {
      if (res && res.data) {
        this.servicerOptions = res.data.list;
      }
    });
  }
  private handleSearch() {
    let id:any;
    if (this.orderForm.servicer === '') {
      id = '';
    } else {
      id = (this.orderForm.servicer as any).servicer_company_id;
    }
    const startTime = Date.parse(this.orderForm.timePeriods[0]) / 1000;
    const endTime = Date.parse(this.orderForm.timePeriods[1]) / 1000;
    const params = {
      order_num: this.orderForm.number,
      // 要求时间为秒
      start_time: isNaN(startTime) ? '' : startTime,
      end_time: isNaN(endTime) ? '' : endTime,
      name: this.orderForm.person,
      servicer_company_id: id
    };
    // 用eventBus来进行兄弟间的组建传值，params为要传递的参数
    eventBus.$emit('orderCheckOrderSearch', params);
  }

  private handleClear() {
    this.orderForm = {
      number: '',
      timePeriods: '',
      person: '',
      servicer: ''
    };
    eventBus.$emit('orderCheckOrderSearch');
  }
}
